import * as Yup from 'yup';
import { isValidPesel } from '../../helpers/validation';

const allowedExtensions = ['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'];

export const sharedBasicSchema = {
    personalInformation: Yup.object().shape({
        name: Yup.string()
            .trim()
            .min(2, 'Imię musi zawierać minimum 2 litery.')
            .required('Pole wymagane'),
        surname: Yup.string().trim().required('Pole wymagane'),
        email: Yup.string().trim().email('Niepoprawny adres email').required('Pole wymagane'),
        phone: Yup.string()
            .trim()
            .matches(/^\+?\d{9,15}$/, 'Niepoprawny numer telefonu')
            .required('Pole wymagane'),
        city: Yup.string()
            .trim()
            .min(2, 'Pole musi zawierać przynajmniej 2 znaki.')
            .required('Pole wymagane')
            .test('alphabets', 'Pole może zawierać tylko litery.', (value) =>
                /^[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ\s]+$/.test(value),
            ),
        zipCode: Yup.string()
            .trim()
            .required('Pole wymagane')
            .matches(/^\d{2}-\d{3}$/, 'Nieprawidłowy kod pocztowy'),
        address: Yup.string()
            .trim()
            .min(2, 'Nazwa ulicy musi zawierać minimum 2 litery')
            .required('Pole wymagane'),
        houseNumber: Yup.string().trim().required('Pole wymagane'),
        noPesel: Yup.bool(),
        pesel: Yup.string().when('noPesel', {
            is: false,
            then: Yup.string()
                .trim()
                .required('Pesel jest wymagany')
                .test('pesel', 'Nieprawidłowy pesel.', (value) => isValidPesel(value)),
        }),
        passportDateOfBirth: Yup.string()
            .nullable()
            .when('noPesel', {
                is: true,
                then: Yup.string().nullable().required('Pole wymagane'),
            }),
        countryOfPassport: Yup.string()
            .nullable()
            .when('noPesel', {
                is: true,
                then: Yup.string().nullable().required('Pole wymagane'),
            }),
        passportNumber: Yup.string()
            .nullable()
            .when('noPesel', {
                is: true,
                then: Yup.string().nullable().required('Pole wymagane'),
            }),
    }),
    privacy: Yup.bool().oneOf([true], 'Pole wymagane'),
    agreement_one: Yup.bool().oneOf([true], 'Pole wymagane'),
    agreement_two: Yup.bool().oneOf([true], 'Pole wymagane'),
    agreement_three: Yup.bool().oneOf([true], 'Pole wymagane'),
};

export const sharedSchema = {
    ...sharedBasicSchema,
    uploadedFile: Yup.array()
        .max(5, 'Maksymalnie można załączyć 5 plików')
        .test('size', 'Maksymalny rozmiar pojedynczego pliku to 5MB', (values) =>
            values.every((file) => file.size <= 5 * 1024 * 1024),
        )
        .test('extension', 'Niepoprawny format plików', (values) =>
            values.every((file) => allowedExtensions.includes(file.type)),
        ),
};
